import React, {useState, useEffect} from "react";
import queryString from "query-string";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";

import BalanceDataTables from "./DataTables";
import StudentInfo from "./StudentInfo";

const StudentFeeStatement = ({match, location}) => {
    const params = queryString.parse(location.search);

    let printHeadTexts = ["معاونیت امور محصلان"];
    let title = 'صورت حساب مالی دانشجو';
    let bodyTitle = {mainTitle: title};

    const [student, setStudent] = useState([]);
    const [summary, setSummary] = useState([]);
    const [payment, setPayment] = useState([]);
    const [discount, setDiscount] = useState([]);

    useEffect(() => {
        requestData();
    }, []);

    const requestData = async () => {
        const {student} = match.params;

        try {
            await db
                .getAll(`students/${student}`)
                .then(({data}) => {
                    if (data && data.data) setStudent(data.data[0])
                });

            await db
                .getAll(`students/${student}/fees`)
                .then(({data}) => {

                    let payments = []
                    let summary = []
                    let discounts = []

                    for (let d of data.data) {
                        payments = [...payments, ...d.payments]
                        discounts = [...discounts, ...d.discounts]

                        let totalPayment = d.payments.reduce((sum, item) => sum + parseFloat(item['amount']), 0);
                        let totalDiscount = d.discounts.reduce((sum, item) => sum + parseFloat(item['amount']), 0);

                        summary.push({
                            semester: d.class_desc,
                            fee: d.fee,
                            discount: totalDiscount,
                            paid: totalPayment,
                            remaining: d.fee - totalDiscount - totalPayment
                        });
                    }

                    discounts.summary = {amount: discounts.reduce((sum, item) => sum + parseFloat(item['amount']), 0)}
                    payments.summary = {amount: payments.reduce((sum, item) => sum + parseFloat(item['amount']), 0)}

                    summary.summary = {
                        fee: summary.reduce((sum, item) => sum + parseFloat(item['fee']), 0),
                        discount: summary.reduce((sum, item) => sum + parseFloat(item['discount']), 0),
                        paid: summary.reduce((sum, item) => sum + parseFloat(item['paid']), 0),
                        remaining: summary.reduce((sum, item) => sum + parseFloat(item['remaining']), 0),
                    }

                    setDiscount(discounts);
                    setPayment(payments);
                    setSummary(summary);
                });

        } catch ({response}) {
            console.log(response);
        }
    };

    return (
        <main className="main-print-wrapper">
            <PrintHeader
                title={title}
                printHeadTexts={printHeadTexts}
            />

            <StudentInfo student={student} />

            <div>
                <PrintBodyTitle
                    title={{mainTitle: lbl.StudentBalanceSummary}}
                />
                <BalanceDataTables
                    name={"summary"}
                    data={summary}
                />
            </div>

            <div>
                <PrintBodyTitle
                    title={{mainTitle: lbl.Discounts}}
                />
                <BalanceDataTables
                    name={"discounts"}
                    data={discount}
                />
            </div>

            <div>
                <PrintBodyTitle
                    title={{mainTitle: lbl.Payments}}
                />
                <BalanceDataTables
                    name={"payments"}
                    data={payment}
                />
            </div>
            <div className="print-signature-area"  style={{marginTop: "100px"}}>
                <div className="wrapper">
                    <hr/>
                    <p>امضا معاونیت امور محصلان</p>
                </div>
            </div>
        </main>
    );
};

export default StudentFeeStatement;
